import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { DailyTripFilter } from '../../../models/trips/dailyTripFilter';

@Component({
  selector: 'daily-trip-filter',
  templateUrl: './daily-trip-filter.component.html',
  styleUrls: ['./daily-trip-filter.component.css']
})
export class DailyTripFilterComponent implements OnInit {
	showFilter: boolean = false;
	
	@Input() filter: DailyTripFilter = new DailyTripFilter();
	@Output() search: EventEmitter<DailyTripFilter> = new EventEmitter<DailyTripFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
        this.filter.tripDate = null;
		this.filter.tripDateFrom = null;
		this.filter.tripDateTo = null;
        this.filter.clientId = null;
		this.filter.tripId = null;
		this.filter.driverId = null;
		this.filter.helperId = null;
		this.filter.bookKeeperId = null;
		this.filter.createdDate = null;
		this.filter.containerNumber = null;
		this.filter.vehicleId = null;
		this.filter.dailyTripTypeId = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/daily-trip-filter/daily-trip-filter.component.ts